var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topImageCss",style:({ 'background-image': 'url(' + 'https://wp-ocssport.ocs-sport.com/pinpos/wp-content/uploads/sites/9/2025/08/pinPosmain-min-1-scaled.png' + ')' }),attrs:{"id":"TopImage"}},[_c('b-container',[_c('h3',{staticClass:"pinPosTitle"},[_vm._v("PRECISION PIN POSITIONING "),_c('br'),_vm._v(" FOR EVERY GREEN")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }